import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "register-form card grid" }
const _hoisted_2 = { class: "title row center" }
const _hoisted_3 = {
  key: 0,
  class: "error row"
}
const _hoisted_4 = {
  key: 1,
  class: "error row"
}
const _hoisted_5 = { class: "form-group col-1" }
const _hoisted_6 = { class: "form-group col-1" }
const _hoisted_7 = { class: "form-group col-1" }
const _hoisted_8 = { class: "form-group col-1" }
const _hoisted_9 = { class: "form-group col-1" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = {
  class: "btn",
  type: "submit"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("hr", { class: "row" }, null, -1)
const _hoisted_13 = { class: "row center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h1", null, _toDisplayString(_ctx.$t("register-title")), 1)
    ]),
    (_ctx.errorText)
      ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.errorText)), 1))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.error)), 1))
      : _createCommentVNode("", true),
    _createVNode("form", {
      class: "row",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.register()), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("input", {
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email.email = $event)),
          type: "email",
          placeholder: _ctx.$t('email')
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.email.email]
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _withDirectives(_createVNode("input", {
          required: "",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email.confirmation = $event)),
          type: "email",
          placeholder: _ctx.$t('email-confirmation')
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.email.confirmation]
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _withDirectives(_createVNode("input", {
          required: "",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.password.password = $event)),
          type: "password",
          placeholder: _ctx.$t('password')
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.password.password]
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _withDirectives(_createVNode("input", {
          required: "",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.password.confirmation = $event)),
          type: "password",
          placeholder: _ctx.$t('password-confirmation')
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.password.confirmation]
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _withDirectives(_createVNode("input", {
          required: "",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.code = $event)),
          type: "input",
          placeholder: _ctx.$t('device.code')
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.code]
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("button", _hoisted_11, _toDisplayString(_ctx.$t("register")), 1)
      ])
    ], 32),
    _hoisted_12,
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_router_link, {
        class: "small",
        to: "/login"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}